import ko from './locales/ko'
import LocalizedStrings from 'react-localization'

let strings = new LocalizedStrings({
  ko: ko,
})
strings.setLanguage('ko')

export default strings
